import React from 'react'
import Modal from 'component/Modal/GenericModal'
import PropTypes from 'prop-types'

const CloseWithoutSaveModal = ({
  translate,
  currentItem,
  newValues,
  file,
  toggle,
  toggleEditModal
}) => (
  <Modal
    renderButton={false}
    onCloseModal={file ? () => toggle(true, file, false, false, {...currentItem, inEdit: true}, newValues) : () => toggleEditModal(true,false)}
    onConfirm={() => file ? () => toggle(false) : toggleEditModal(false, false)}
    size='sm'
    isOpen
    center
    noCloseOnConfirm
    showHeader={false}
    cancelButtonText={translate('button.cancel')}
    confirmButtonText={translate('out.without.save.confirm')}
    confirmType='danger'
  >
    <div className='irc-supply-confirm'>
      <h4>{translate('out.without.save')}</h4>
      <span>{translate('out.without.save.msg.1')}</span>
      <span>{translate('out.without.save.msg.2')}</span>
    </div>
  </Modal>
)

CloseWithoutSaveModal.propTypes = {
  translate: PropTypes.func,
  currentItem: PropTypes.object,
  newValues: PropTypes.object,
  file: PropTypes.any,
  toggle: PropTypes.func,
  toggleEditModal: PropTypes.func
}

export default CloseWithoutSaveModal
